import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "form", "nameInput", "urlInput", "errors"]
  static values = { open: Boolean }

  connect() {
    this.syncPanel()
    if (this.openValue) this.focusNameInput()
  }

  open(event) {
    event.preventDefault()
    this.openValue = true
  }

  close(event) {
    event.preventDefault()
    this.clearForm()
    this.openValue = false
  }

  openValueChanged() {
    this.syncPanel()
    if (this.openValue) this.focusNameInput()
  }

  syncPanel() {
    if (!this.hasPanelTarget) return

    this.panelTarget.classList.toggle("hidden", !this.openValue)
  }

  clearForm() {
    if (this.hasFormTarget) this.formTarget.reset()

    if (this.hasNameInputTarget) {
      this.nameInputTarget.value = ""
      this.nameInputTarget.className = this.nameInputTarget.dataset.defaultClass
    }

    if (this.hasUrlInputTarget) {
      this.urlInputTarget.value = ""
      this.urlInputTarget.className = this.urlInputTarget.dataset.defaultClass
    }

    this.errorsTargets.forEach((element) => element.remove())
  }

  focusNameInput() {
    requestAnimationFrame(() => {
      if (this.hasNameInputTarget) this.nameInputTarget.focus()
    })
  }
}
